<mat-toolbar>
  Select Event
  <div class="spacer"></div>
  <div class="actions">
    <button mat-stroked-button (click)="cancel.emit()">Cancel</button>
    <button mat-stroked-button (click)="skip.emit()">Skip</button>
  </div>
</mat-toolbar>

<div>
  <mat-form-field class="hint">
    <input matInput placeholder="Search" [disabled]="false" (keyup)="changeSearch($event.target.value)" />
    <mat-hint>EventTypeID</mat-hint>
  </mat-form-field>
</div>
<div class="list mat-elevation-z1">
  @if (!loading && error) {
    <div class="message">Failed to load events</div>
  }
  @if (events.length === 0 && !loading && !error) {
    <div class="message">There are no events.</div>
  }
  @if (events.length > 0) {
    <mat-nav-list>
      @for (event of events; track event) {
        <mat-list-item (click)="selected.emit(event)">
          <span matListItemTitle>{{ event.name }}</span>
          <span matListItemLine>{{ event.description }}</span>
        </mat-list-item>
      }
    </mat-nav-list>
  }
</div>
@if (loading || hasMore) {
  <div class="load-more">
    @if (loading) {
      <mat-spinner [diameter]="24"></mat-spinner>
    }
    @if (hasMore && !loading) {
      <button mat-stroked-button (click)="loadMore.emit()">Load more</button>
    }
  </div>
}
